import { ThemeConfig } from "../../../shared/theme";
import * as theme from './pgl';
const ThemeComponents: ThemeConfig = {
    'pgl': {
        component: theme,
        css: ['/static/customized/themes/pgl/css/extension.css', '/static/customized/themes/pgl/css/common.css', '/static/customized/themes/pgl/css/blue.css'],
        layouts: {
            'default': theme.DefaultLayout,
            'empty': theme.EmptyLayout
        }
    }
};

export default ThemeComponents;